import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

/**
 * The portfolio name rule, mirrored from the CRM backend's PublicPortfolioNameValidator so the operator
 * learns about a bad name before saving: Unicode NFC normalisation, trim, 1 to 20 characters, letters,
 * digits, spaces and the punctuation . , ' & - _ ( ). Uniqueness per client stays a backend answer (409).
 */
export class PublicPortfolioNameValidator {
    private static readonly allowedCharacters = new RegExp('^[\\p{L}\\p{N} .,\'&\\-_()]+$', 'u');

    public static readonly MaxLength = 20;
    public static readonly ErrorKey = 'portfolioName';

    /** The name as the backend will store it, or null when it is not acceptable. */
    static normalize(name: string | null | undefined): string | null {
        if (name === null || name === undefined) {
            return null;
        }

        const normalized = name.normalize('NFC').trim();
        if (normalized.length === 0 || normalized.length > PublicPortfolioNameValidator.MaxLength) {
            return null;
        }

        return PublicPortfolioNameValidator.allowedCharacters.test(normalized) ? normalized : null;
    }

    static validate(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return PublicPortfolioNameValidator.normalize(control.value) === null
                ? {[PublicPortfolioNameValidator.ErrorKey]: true}
                : null;
        };
    }
}
